import ActivityServices from '../../services/activities/Activity';

export const state = {
    coordinators: [],
    coordinator: {},
}

export const mutations = {
    setCoordinator(state, coordinator) {
        state.coordinator = coordinator
    },
    setCoordinators(state, coordinators) {
        state.coordinators = coordinators
    }
}

export const getters = {
    getCoordinator(state) {
        return state.coordinator;
    },
    getCoordinators(state) {
        return state.coordinators;
    },
}

export const actions = {
    get({commit}, id){
        return ActivityServices.get(id)
        .then((response)=>{
            commit('setCoordinator', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return ActivityServices.getAll(data)
        .then((response)=>{
            commit('setCoordinators', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return ActivityServices.delete(id)
        .then((response)=>{
            commit('setCoordinators', state.coordinators.filter((x)=>x.id != id))
            return response
        })
    },
}